$(document).ready(function () {
  $('ul.tabs-menu-product li').click(function () {
    $('ul.tabs-menu-product li').removeClass('active')
    $(this).addClass('active');
  });
  if ($('section.cube-peel .list-item').length > 0) {
    $('section.cube-peel .list-item').addClass('owl-carousel');
    $('section.cube-peel .list-item.owl-carousel').owlCarousel({
      loop: true,
      margin: 40,
      nav: true,
      responsive: {
        0: {
          items: 2,
          margin: 15
        },
        280: {
          items: 2,
          margin: 15
        },
        767: {
          items: 3
        }
      }
    });
  };
  $('ul.tabs-menu-product li a').on('click', function (e) {
    $("ul.tabs-menu-product li a").removeClass("active");
    $(this).addClass("active");
    var currentId = $(this).attr('href');
    var pos = $(currentId).offset().top;
    e.preventDefault();
    $('html,body').animate({
      scrollTop: pos - 50
    }, 500);
    return false;
  });
  setTimeout(function () {
    $('.block__recommended-products .container .list-item').addClass('owl-carousel');
    $('.block__recommended-products .container .list-item.owl-carousel').owlCarousel({
      loop: true,
      margin: 40,
      nav: true,
      responsive: {
        0: {
          items: 1,
          margin: 15
        },
        280: {
          items: 1,
          margin: 15
        },
        767: {
          items: 3
        }
      }
    });
  }, 4000);

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    if (exdays > 0) {
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      var expires = "expires=" + d.toUTCString();
    } else {
      var expires = "expires=";
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  $('.shopify-product-form .button--add-to-cart').click(function () {
    if (getCookie('reloaded') != 1 && getCookie('reloaded') != 2) {
      setCookie('reloaded', 1, 1);
      let _addToCartForm = $(this).closest('form');
      setCookie('product', _addToCartForm.serialize(), 1);
      setTimeout(function () {
        location.reload();
      }, 1000)
    }
  });
  if (getCookie('reloaded') == 1) {
    var dataAdd = getCookie('product');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: dataAdd,
      success: function success(product) {
        setCookie('reloaded', 2, 1);
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest) {
        console.log(XMLHttpRequest);
      }
    })
  }
  $('.swatch-option').click(function () {
    var value = $(this).find('.swatch__value').text();
    $(this).closest('.product-form__input').find('.selected-option').text(value);
  })
});
